import { ExtendedFile } from "~graphql/sdk";

export const getGCSFile = (file?: ExtendedFile, fallback: string = undefined) =>
  file
    ? `${process.env.GCS_ENDPOINT}/${file?.directory}/${file?.fileName}`
    : fallback ?? "/static/no-image.jpg";
